import { Component, OnInit, ViewChild } from "@angular/core";

import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

import { ActivatedRoute, Router } from "@angular/router";

import axios from "src/app/Service/axios";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import TileLayer from 'ol/layer/Tile';

import { MapService } from 'src/app/Service/map.service';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions, Draw

} from 'ol/interaction';

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { Polygon } from "ol/geom";

import Feature from "ol/Feature";

import { Fill, Stroke, Style } from "ol/style";

import BingMaps from "ol/source/BingMaps";

import { defaults as defaultControls, FullScreen } from 'ol/control';

import { DeviceDetectorService } from "ngx-device-detector";

import { GurdServiceService } from "src/app/Service/gurd-service.service";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { XYZ } from "ol/source";

declare let $: any;

@Component({

  selector: 'app-route-management',

  templateUrl: './route-management.component.html',

  styleUrls: ['./route-management.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class RouteManagementComponent implements OnInit {

  list_Station: any = [];

  list_Station_Search: any = [];

  list_Route: any = [];

  list_Route_Search: any = [];

  list_Route_Station: any = [];

  list_Route_Users: any = [];

  full_list_Route_Users: any = [];

  list_RouteCost: any = [];

  list_MobileType: any = [];

  bStation: boolean = true;

  mapSatelait: boolean = false;

  ismapCreate: boolean = false;

  editMode: boolean = false;

  bRoute_Station: boolean = false;

  bRouteCost: boolean = false;

  bEditMode: boolean = false;

  map: any;

  source: any;

  vector: any;

  layers: any = [];

  polygonEvent: any;

  draw: any;

  search_Station = '';

  filtered_Station = [];

  vectorLayer: any;

  saveStationForm: FormGroup = this.formBuilder.group({

    iRoute_Station: new FormControl(),

    strName: new FormControl(),

    strCode: new FormControl(),

    strComment: new FormControl(""),

    lstPoints: new FormControl(""),

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  });

  saveRouteForm: FormGroup = this.formBuilder.group({

    iRoute: new FormControl(""),

    strCode: new FormControl(""),

    strName: new FormControl(""),

    strComment: new FormControl(""),

    strColor: new FormControl("#2563eb"),

    iLength: new FormControl(""),

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  });

  saveRoute_Station_Form: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iRoute: new FormControl(""),

    iRoute_Station: new FormControl(""),

    iRoute_Stations: new FormControl(""),

    tiType: new FormControl(""),

    strComment: new FormControl(""),

    iIndex: new FormControl(this.list_Route_Station.length + 1),

    iMinPresence: new FormControl("0"),

  });

  saveRouteCost: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    tiMobileType: new FormControl('-1'),

    iRoute_MobileType_Cost: new FormControl(''),

    iRoute: new FormControl(''),

    iCost: new FormControl(''),

    tiIndex: new FormControl(''),

  });

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private notifyService: NotificationService,

    private router: Router,

    private otherService: OtherService,

    private formBuilder: FormBuilder,

    private route: ActivatedRoute,

    private mapService: MapService,

    private deviceService: DeviceDetectorService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.get_Station();

    this.get_Route();

    this.getMobileType()

  }

  get_Station = async () => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_Station_List`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_Station = res;

    this.list_Station_Search = res;

  }

  get_Route = async () => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_List`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_Route = res;

    this.list_Route_Search = res;

  }

  getMobileType = async () => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    this.otherService.Showspinner();

    const resp = await axios.post(`GetMobileType`, model);

    this.otherService.nonespinner();

    this.list_MobileType = resp.data;

  }

  newOpenMap() {

    this.editMode = false;

    if (this.saveStationForm.get('lstPoints')?.value != '') {

      this.mapService.removeLayerByName('polygon', this.map);

    }

    this.saveStationForm.patchValue({

      iRoute_Station: "",

      strName: "",

      strCode: "",

      strComment: "",

      lstPoints: "",

    })

    setTimeout(() => {

      if (!this.ismapCreate) {

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({

          source: this.source,

        });

        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(

              new TileLayer({

                visible: false,

                // visible: (styles[i] === 'AerialWithLabelsOnDemand') ? true : false,

                preload: Infinity,

                source: new BingMaps({

                  // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
                  imagerySet: styles[i],

                }),

              }),

            );
          }

          // this.layers.push(new TileLayer({ source: new OSM({}),visible: false }), this.vector)

          this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)


        }

        this.map = new Map({

          layers: this.layers,

          target: 'test',

          view: new View({

            center: olProj.fromLonLat([51.3833554, 35.6770113]),

            zoom: 13,

          }),

        });

        this.ismapCreate = true;

      }

    }, 500);

    setTimeout(() => {

      this.vector.getSource().on('addfeature', (e: any) => {

        this.polygonEvent = e.feature;

        this.source.removeFeature(e.feature);

        this.source.removeFeature(this.polygonEvent);

        this.savePolygon();

      });

      const value = 'Polygon';

      this.draw = new Draw({

        source: this.source,

        type: value,

      });

      this.map.addInteraction(this.draw);

    }, 700);

  }

  savePolygon = async () => {

    var point = [] as any;

    this.draw.sketchLineCoords_.forEach((item: any, index: any) => {

      var data = this.mapService.transformCoordinates(item);

      point.push({ fLat: data[1], fLon: data[0] });

    });

    this.notifyService.showSuccess("محدوده با موفقیت ترسیم شد.");

    this.showPolygon(point);

    this.saveStationForm.controls["lstPoints"].setValue(point);

  }

  newStation = async () => {

    var model = this.saveStationForm.value;

    if (!model.strName || !model.strCode || !model.lstPoints.length) return this.notifyService.showError("لطفا فرم را با دقت تکمیل کنید");

    const resp = await axios.post(`Route_Station_Save`, model);

    this.otherService.Showspinner();

    this.otherService.nonespinner();

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    else {

      this.notifyService.showSuccess("با موفقیت ثبت شد");

      this.list_Station.push(resParse[0]);

      $("#Add-station-modal").modal("hide");

    }


  }

  editStation = async () => {

    var model = this.saveStationForm.value;

    if (!model.strName || !model.strCode || !model.lstPoints.length) return this.notifyService.showError("لطفا فرم را با دقت تکمیل کنید");

    const resp = await axios.post(`Route_Station_Edit`, model);

    this.otherService.Showspinner();

    this.otherService.nonespinner();

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    else {

      this.notifyService.showSuccess("با موفقیت ویرایش شد");

      const Station = this.list_Station.filter((el: any) => {

        return el.iRoute_Station == model.iRoute_Station;

      });

      const index = this.list_Station.indexOf(Station[0]);

      if (index != -1) this.list_Station[index] = resParse[0];

      $("#Add-station-modal").modal("hide");

      this.editMode = false;


    }


  }

  deleteStation(item: any) {

    $.confirm({

      title: `آیا از حذف این ایستگاه اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              iRoute_Station: item.iRoute_Station,

            };

            const resp = await axios.post(`Route_Station_Delete`, model);

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

            if (resParse.ISSessionExpired == true) {

              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            }

            else {

              this.notifyService.showSuccess("با موفقیت حذف شد");

              this.list_Station = this.list_Station.filter((el: any) => {

                return el.iRoute_Station != item.iRoute_Station;

              });

            }

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  newRoute = async () => {

    var model = this.saveRouteForm.value;

    if (!model.strName || !model.strCode || !model.strColor) return this.notifyService.showError("لطفا فرم را با دقت تکمیل کنید");

    const resp = await axios.post(`Route_Save`, model);

    this.otherService.Showspinner();

    this.otherService.nonespinner();

    let resParse = JSON.parse(resp.data);

    if (resParse.bError) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (!resParse.bError) {

      this.notifyService.showSuccess("با موفقیت ثبت شد");

      this.list_Route.push(resParse[0]);

      $("#Add-Route-modal").modal("hide");

    }

  }

  editRoute = async () => {

    var model = this.saveRouteForm.value;

    if (!model.strName || !model.strCode || !model.strColor) return this.notifyService.showError("لطفا فرم را با دقت تکمیل کنید");

    const resp = await axios.post(`Route_Edit`, model);

    this.otherService.Showspinner();

    this.otherService.nonespinner();

    let resParse = JSON.parse(resp.data);

    if (resParse.bError) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (!resParse.bError) {

      this.notifyService.showSuccess("با موفقیت ویرایش شد");

      const Route = this.list_Route.filter((el: any) => {

        return el.iRoute == model.iRoute;

      });

      const index = this.list_Route.indexOf(Route[0]);

      if (index != -1) this.list_Route[index] = resParse[0];

      $("#Add-Route-modal").modal("hide");

      this.editMode = false;

    }

  }

  editStation_Modal(item: any) {

    // console.log(item.lstPoints)

    // const lstPoints = [
    //   {
    //     "fLat": 35.66738911457503,
    //     "fLon": 51.35571791831055
    //   },
    //   {
    //     "fLat": 35.68495918690938,
    //     "fLon": 51.35091139975586
    //   },
    //   {
    //     "fLat": 35.69053617867446,
    //     "fLon": 51.39348342124023
    //   },
    //   {
    //     "fLat": 35.66920207877466,
    //     "fLon": 51.40549971762696
    //   },
    //   {
    //     "fLat": 35.66236838345236,
    //     "fLon": 51.390221855078124
    //   }
    // ]

    this.editMode = true;

    Object.keys(item).forEach(key => {

      this.saveStationForm.get(key)?.setValue(item[key])

    })

    setTimeout(() => {

      this.showPolygon(item.lstPoints)

    }, 800);

    setTimeout(() => {

      if (!this.ismapCreate) {

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({

          source: this.source,

        });


        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(

              new TileLayer({

                visible: false,

                preload: Infinity,

                source: new BingMaps({

                  // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


                  imagerySet: styles[i],

                }),

              }),

            );
          }

          this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


        }

        this.map = new Map({

          layers: this.layers,

          target: 'test',

          view: new View({

            center: olProj.fromLonLat([51.3833554, 35.6770113]),

            zoom: 13,

          }),

        });

        this.ismapCreate = true;
      }

    }, 500);

    setTimeout(() => {

      this.vector.getSource().on('addfeature', (e: any) => {

        this.polygonEvent = e.feature;

        this.source.removeFeature(e.feature);

        this.source.removeFeature(this.polygonEvent);

        this.savePolygon();

      });

      const value = 'Polygon';

      this.draw = new Draw({

        source: this.source,

        type: value,

      });

      this.map.addInteraction(this.draw);

    }, 700);

  }

  showPolygon(point: any[],) {

    // Remove the previous polygon

    if (this.vectorLayer) this.map.removeLayer(this.vectorLayer);

    if (point.length != 0) {

      var ring = [];

      for (let index = 0; index < point.length; index++) {

        ring.push([point[index].fLon, point[index].fLat]);

      }

      var polygon = new Polygon([ring]);

      polygon.transform('EPSG:4326', 'EPSG:3857');

      var feature = new Feature(polygon);

      var vectorSource = new VectorSource();

      vectorSource.addFeature(feature);

      var vectorLayer = new VectorLayer({

        source: vectorSource,

        name: 'polygon',

        style: new Style({

          stroke: new Stroke({

            color: 'red',

            width: 4,

            lineDash: [10, 20, 10, 20]

          }),

          fill: new Fill({

            color: 'rgba(0, 0, 255, 0)'

          })

        }),

      } as any);


      this.vectorLayer = vectorLayer;

      this.map.addLayer(vectorLayer);

      this.fitToAll(point);


    }

  }

  fitToAll(obj: any[]) {

    let maxLatitude = -Infinity;

    let maxLongitude = -Infinity;

    let minLatitude = Infinity;

    let minLongitude = Infinity;

    for (const item of obj) {

      if (item.fLat > maxLatitude) maxLatitude = item.fLat;

      if (item.fLon > maxLongitude) maxLongitude = item.fLon;

      if (item.fLat < minLatitude) minLatitude = item.fLat;

      if (item.fLon < minLongitude) minLongitude = item.fLon;
    }

    var model: any = {

      maxLatitude: maxLatitude,

      maxLongitude: maxLongitude,

      minLatitude: minLatitude,

      minLongitude: minLongitude

    }

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([

      model.maxLongitude,

      model.maxLatitude,

    ]);

    var transformedEnd = this.mapService.transformCoordinates2([

      model.minLongitude,

      model.minLatitude,

    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
    ];

    view.fit(source);
  }

  editRoute_Modal(item: any) {

    this.editMode = true;

    Object.keys(item).forEach(key => {

      this.saveRouteForm.get(key)?.setValue(item[key].toString().trim())

    })

  }

  deleteRoute(item: any) {

    $.confirm({

      title: `آیا از حذف این مسیر اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              iRoute: item.iRoute,

            };

            const resp = await axios.post(`Route_Delete`, model);

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

            if (resParse.ISSessionExpired == true) {

              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            }

            else {

              this.notifyService.showSuccess("با موفقیت حذف شد");

              this.list_Route = this.list_Route.filter((el: any) => {

                return el.iRoute != item.iRoute;

              });

            }

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  changeTail() {

    if (this.mapSatelait == false) {

      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);

    }

    else {

      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);

    }

    this.mapSatelait = !this.mapSatelait;

  }

  filterStation(val: any) {

    this.list_Station = this.list_Station_Search.filter((el: any) => {

      return el.strName.includes(val.value) || el.strCode.includes(val.value);

    });

    if (val.value.trim() == '') {

      this.list_Station = this.list_Station_Search

    }

  }

  filterRoute(val: any) {

    this.list_Route = this.list_Route_Search.filter((el: any) => {

      return el.strName.includes(val.value) || el.strCode.includes(val.value);

    });

    // if (this.list_Station.length == 0) this.list_Route = this.list_Route_Search

    if (val.value.trim() == '') {

      this.list_Route = this.list_Route_Search
    }

  }

  reset_Route_Value() {

    this.editMode = false;

    this.saveRouteForm.patchValue({

      iRoute: "",

      strCode: "",

      strName: "",

      strComment: "",

      strColor: "#2563eb",

      iLength: "",

    });


  }

  get_Route_Station = async (item: any) => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iRoute: item.iRoute

    };

    this.saveRoute_Station_Form.controls['iRoute'].setValue(item.iRoute);

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_Stations_List`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_Route_Station = res;

    this.bRoute_Station = false;

    this.editMode = false;

    $("#Add-Route-Station-modal").modal("show");


  }

  delete_Route_Station(item: any) {

    $.confirm({

      title: `آیا از حذف این ایستگاه اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              iRoute_Stations: item.iRoute_Stations,

            };

            const resp = await axios.post(`Route_Stations_Delete`, model);

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

            if (resParse.ISSessionExpired == true) {

              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            }

            else {

              this.notifyService.showSuccess("با موفقیت حذف شد");

              this.list_Route_Station = this.list_Route_Station.filter((el: any) => {

                return el.iRoute_Stations != item.iRoute_Stations;

              });

            }

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  filter_Station_() {

    if (this.search_Station == '') {

      this.filtered_Station = this.list_Station;

      this.saveRoute_Station_Form.controls['iRoute_Station'].setValue('');

    }

    else this.filtered_Station = this.list_Station.filter((item: any) => item.strName.includes(this.search_Station));

  }

  selected_Station(item: any) {

    this.saveRoute_Station_Form.controls['iRoute_Station'].setValue(item.iRoute_Station);

    this.filtered_Station = [];

    this.search_Station = item.strName;

  }

  new_RouteStation = async () => {

    var model = this.saveRoute_Station_Form.value;

    if (model.iRoute_Station == '' || model.tiType == -1) return this.notifyService.showError("لطفا فرم را با دقت تکمیل کنید");

    const resp = await axios.post(`Route_Stations_Save`, model);

    this.otherService.Showspinner();

    this.otherService.nonespinner();

    let resParse = JSON.parse(resp.data);

    if (resParse.bError) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (!resParse.bError) {

      this.notifyService.showSuccess("با موفقیت ثبت شد");

      this.list_Route_Station.push(resParse[0]);

      this.bRoute_Station = false;
    }

  }

  show_RouteStation_Form() {

    this.saveRoute_Station_Form.patchValue({

      iRoute_Station: "",

      tiType: "",

      strComment: "",

      iIndex: this.list_Route_Station.length + 1,

      iMinPresence: "0",

    })

    this.search_Station = '';

    this.bRoute_Station = true;

  }

  show_RouteStation_Form_Edit(item: any) {

    const Station = this.list_Route_Station.filter((el: any) => {

      return el.iRoute_Station == item.iRoute_Station;

    });

    this.selected_Station(Station[0])

    Object.keys(item).forEach(key => {

      this.saveRoute_Station_Form.get(key)?.setValue(item[key])

    })

    this.editMode = true;

    this.bRoute_Station = true;

  }

  edit_RouteStation = async () => {

    var model = this.saveRoute_Station_Form.value;

    if (model.iRoute_Station == '' || model.tiType == -1) return this.notifyService.showError("لطفا فرم را با دقت تکمیل کنید");

    const resp = await axios.post(`Route_Stations_Edit`, model);

    this.otherService.Showspinner();

    this.otherService.nonespinner();

    let resParse = JSON.parse(resp.data);

    if (resParse.bError) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (!resParse.bError) {

      this.notifyService.showSuccess("با موفقیت ویرایش شد");

      const Route = this.list_Route_Station.filter((el: any) => {

        return el.iRoute_Stations == model.iRoute_Stations;

      });

      const index = this.list_Route_Station.indexOf(Route[0]);

      if (index != -1) this.list_Route_Station[index] = resParse[0];

      this.editMode = false;

      this.bRoute_Station = false;

    }

  }

  filter_RouteUser(val: any) {

    this.list_Route_Users = this.full_list_Route_Users.filter((el: any) => {

      return el.strFullName.includes(val.value) || el.strMobile_strComment.includes(val.value);

    });

    if (val.trim() == '') this.list_Route_Users = this.full_list_Route_Users;

  }

  get_Route_Users = async (item: any) => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iRoute: item.iRoute

    };

    this.saveRoute_Station_Form.controls['iRoute'].setValue(item.iRoute);

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_SystemUser_List`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_Route_Users = res;

    this.full_list_Route_Users = res;

    $("#Route-user-modal").modal("show");

  }

  onCheckbox_User_Route = async (value: boolean, item: any) => {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iRoute: this.saveRoute_Station_Form.get('iRoute')?.value,

      iSystemUser_User: item.iSystemUser

    }

    let res = JSON.parse((await axios.post(`Route_SystemUser_SaveOrDelete`, model)).data.toString());

    if (res.bError) return this.notifyService.showError(res.strError)

    else return this.notifyService.showSuccess('عملیات با موفقیت انجام شد');

  }

  addOrRemoveAllUser = async (bAdd: boolean) => {

    $.confirm({

      title: `آیا از ${bAdd ? ' انتخاب همه ' : ' حذف همه '} اطمینان دارید ؟`,

      content: '',

      type: bAdd ? 'blue' : 'red',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: bAdd ? 'btn-primary' : 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iRoute: this.saveRoute_Station_Form.get('iRoute')?.value,

              bAdd: bAdd

            }

            const resp = await axios.post(`Route_SystemUser_AddOrRemoveAllUser`, model);

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

            if (resParse.ISSessionExpired == true) {

              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;

            }

            else {

              this.notifyService.showSuccess('عملیات با موفقیت انجام شد');

              $('#Route-user-modal').modal('hide')

            }

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  get_Route_Costs = async (item: any) => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iRoute: item.iRoute

    };

    this.saveRoute_Station_Form.controls['iRoute'].setValue(item.iRoute);

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_MobileType_Cost_List`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_RouteCost = res;

    this.saveRouteCost.patchValue({

      tiMobileType: '-1',

      iRoute_MobileType_Cost: '',

      iRoute: item.iRoute,

      iCost: '',

    })

    this.bEditMode = false;

    $("#Route_Cost-modal").modal('show')


  }

  delete_Route_Cost(item: any) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              iRoute_MobileType_Cost: item.iRoute_MobileType_Cost,

            };

            const resp = await axios.post(`Route_MobileType_Cost_Delete`, model);

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

            if (resParse.ISSessionExpired == true) {

              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            }

            else {

              this.notifyService.showSuccess("با موفقیت حذف شد");

              this.list_RouteCost = this.list_RouteCost.filter((el: any) => {

                return el.iRoute_MobileType_Cost != item.iRoute_MobileType_Cost;

              });

            }

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  add_RouteCost = async () => {

    var model = this.saveRouteCost.value;

    if (model.tiMobileType == '-1' || model.iCost.trim() == '') return this.notifyService.showError('لطا موارد ستاره دار را وارد کنید');

    model.iCost = model.iCost.toString().replace(/,/g, '');

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_MobileType_Cost_Save`, model);

    this.otherService.nonespinner();

    let resParse = JSON.parse(resp.data);

    if (resParse.bError) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (!resParse.bError) {

      this.notifyService.showSuccess("با موفقیت ثبت شد");

      this.list_RouteCost.push(resParse[0]);

      this.bRouteCost = false;

      this.saveRouteCost.patchValue({

        tiMobileType: '-1',

        iRoute_MobileType_Cost: '',

        iCost: '',

      })

    }

  }

  edit_RouteCost = async () => {

    var model = this.saveRouteCost.value;

    if (model.tiMobileType == '-1' || model.iCost.trim() == '') return this.notifyService.showError('لطا موارد ستاره دار را وارد کنید');

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            model.iCost = model.iCost.toString().replace(/,/g, '');

            this.otherService.Showspinner();

            const resp = await axios.post(`Route_MobileType_Cost_Edit`, model);

            this.otherService.nonespinner();

            let resParse = JSON.parse(resp.data);

            if (resParse.bError) return this.notifyService.showError(resParse.strError);

            if (resParse.ISSessionExpired == true) {

              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;

            }

            if (!resParse.bError) {

              this.notifyService.showSuccess("با موفقیت ویرایش شد");

              this.list_RouteCost[this.saveRouteCost.get('tiIndex')?.value] = resParse[0];

              this.bRouteCost = false;

              this.bEditMode = false;

              this.saveRouteCost.patchValue({

                tiMobileType: '-1',

                iRoute_MobileType_Cost: '',

                iCost: '',

                tiIndex: ''

              })

            }

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  editModal_Cost(item: any, index: number) {

    this.bEditMode = true;

    this.bRouteCost = true;

    this.saveRouteCost.controls['tiIndex'].setValue(index);

    item.iCost = item.iCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    Object.keys(item).forEach((key) => {

      this.saveRouteCost.get(key)?.setValue(item[key])

    })

  }

  openNewRoute() {

    this.bRouteCost = true;

    this.bEditMode = false;

    this.saveRouteCost.patchValue({

      tiMobileType: '-1',

      iRoute_MobileType_Cost: '',

      iCost: '',

    })

  }

}
